import React from 'react';
import { Helmet } from 'react-helmet';
import axios from "axios";
import Api from "../../assets/js/utils/Api";
import { helper } from "../../assets/js/utils/Element";
import LoaderComponent from "../components/Loader";
import Button from "../components/CustomButtons/Button";
import { Link as RouterLink } from 'react-router-dom';

// Landing page for the Phase B magic link: /s/{hash}/verify?token=...
// Verifies the magic token, then forwards to the download page with the
// resulting share session, or shows an error with a way to request a new code.
const ShareVerify = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        this.history = this.props.history;

        let hash = "";
        // The /s/:hash/verify route passes the real react-router match directly
        // (component={({match}) => ...}), matching the /downloads route pattern.
        const { match } = this.props;
        if(match && match.params && match.params.hasOwnProperty("hash")){
            hash = match.params.hash;
        }
        let token = helper.getParam("token");
        if(!token || token === "null"){
            token = null;
        }

        this.state = {
            hash: hash,
            token: token,
            loading: true,
            error: false,
            errorMessage: null,
            cancelToken: null
        };
    }
    componentDidMount(){
        this.verify();
    }
    componentWillUnmount(){
        if(this.state.cancelToken){
            this.state.cancelToken.cancel('Request Cancelled');
        }
    }
    verify(){
        const { hash, token } = this.state;
        if(!token){
            this.setState({ loading: false, error: true, errorMessage: "This verification link is invalid or has expired." });
            return;
        }
        const source = axios.CancelToken.source();
        this.setState({ cancelToken: source });
        Api.verifyShare(hash, { magicToken: token }, source).then(data => {
            if(data && data.verified === true && data.sessionToken){
                this.history.push("/downloads/" + hash + "?session=" + encodeURIComponent(data.sessionToken));
                return;
            }
            this.setState({
                loading: false,
                error: true,
                errorMessage: (data && data.message) ? data.message : "This verification link is invalid or has expired."
            });
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({
                    loading: false,
                    error: true,
                    errorMessage: (err && err.message) ? err.message : "This verification link is invalid or has expired."
                });
            }
        });
    }
    render(){
        const { loading, error, errorMessage, hash } = this.state;
        return (
            <div style={{ maxWidth: "480px", margin: "120px auto", textAlign: "center", padding: "0 16px" }}>
                <Helmet>
                    <title>{process.env.REACT_APP_TITLE}</title>
                </Helmet>
                {
                    loading ?
                        <>
                            <LoaderComponent color="custom" align="center" />
                            <p>Verifying your link&hellip;</p>
                        </>
                    :
                        <>
                            <h2>{ error ? "Verification failed" : "Verified" }</h2>
                            <p>{errorMessage}</p>
                            <RouterLink to={"/downloads/" + hash}>
                                <Button color="custom">Request a new code</Button>
                            </RouterLink>
                        </>
                }
            </div>
        );
    }
}

export default ShareVerify;
